
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CTA = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col md:flex-row gap-8 items-center">
          <div className="w-full md:w-2/3">
            <h2 className="text-3xl font-bold mb-4">Get started with Visa Now</h2>
            <p className="text-gray-600 mb-8">
              Join thousands of users who are successfully navigating their international journeys with our comprehensive platform.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/tools">
                <Button className="bg-black hover:bg-black/90 text-white">Sign up for free</Button>
              </Link>
              <Button variant="outline" className="border-gray-300">
                Talk to sales
              </Button>
            </div>
          </div>
          
          <div className="w-full md:w-1/3">
            <img 
              src="https://images.unsplash.com/photo-1551836022-d5d88e9218df" 
              alt="Happy user with laptop" 
              className="w-full h-auto rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
